export const AUTHENTICATED = 'AUTHENTICATED';
export const ADD_STUDENT = 'ADD_STUDENT';
export const ADD_PATHWAY = 'ADD_PATHWAY';
export const POPULATE_MY_SCHOOL = 'POPULATE_MY_SCHOOL';
export const SET_UP_DATA_INSIGHT = 'SET_UP_DATA_INSIGHT';
export const UPDATE_ASSIGNMENT = 'UPDATE_ASSIGNMENT';
export const SELECT_STUDENT = 'SELECT_STUDENT';
export const ADD_PMSTUDENT = 'ADD_PMSTUDENT';
export const SETUP_STUDENT = 'SETUP_STUDENT';
